module.exports = __webpack_public_path__ + "static/media/collapse.ccbdde7c.svg";